// import { Notification } from 'element-ui'
import store from 'public/store'
import bus from 'public/utils/bus'
import service, { http } from 'public/utils/http'
import { API, LOGIN_ERROR_TYPES, ENV } from 'public/config'
import { random, getToken, setToken, defineFreezeProperty } from 'public/utils'

/**
 * 密码过期提示
 * @param text
 */
// function pwdExpiredTips (text) {
//   if (text) {
//     let msg = `${text}<br/><a href="/#/uamp/edit-password" style="color:#8b60f0;">立即修改</a>`
//     setTimeout(_ => {
//       Notification({
//         title: '请尽快修改密码',
//         type: 'warning',
//         duration: 0,
//         offset: 64,
//         dangerouslyUseHTMLString: true,
//         message: msg
//       })
//     }, 1000)
//   }
// }

/**
 * 检查是否需要刷新页面
 * 1. 切换了账号登录并且登录前未刷新页面
 * 2. 灰度版本
 * 3. 不是灰度版本并且cookie有灰度标识
 */
function checkReload (isReload, gray) {
  // let cookie = document.cookie || ''
  // sessionStorage.removeItem('GLOBAL_USER_GRAY')
  // if (gray) {
  //   isReload = true
  //   sessionStorage.setItem('GLOBAL_USER_GRAY', '1')
  //   console.log('caslogin:gray', gray, document.cookie)
  // } else if (!gray && cookie.includes('gray=')) {
  //   isReload = true
  //   let now = new Date()
  //   now.setTime(now.getTime() - 1)
  //   document.cookie = `gray=0;expires=${now.toGMTString()}`
  //   console.log('caslogin:gray', gray, document.cookie)
  // }

  if (isReload) {
    window.__intercept__ = 0
    location.reload()
  }
}

const axios = {
  cancel: true,
  axios: {
    headers: {
      'X-menu-id': '2820215716730110'
    }
  }
}

// 检测框架包是否被设置为灰度
function checkPublicGray (modules = []) {
  const isPublic = modules.includes('public')
  const cookie = document.cookie || ''
  let isReload = false
  // 1、有public但未设置cookie；2、已设置cookie但无public
  if (isPublic && !cookie.includes('gray=1')) {
    isReload = true
    document.cookie = `gray=1`
  } else if (!isPublic && cookie.includes('gray=')) {
    let now = new Date()
    isReload = true
    now.setTime(now.getTime() - 1)
    document.cookie = `gray=0;expires=${now.toGMTString()}`
  }

  return isReload
}

// 2022-07-20 前端灰度包
async function checkGrayModules () {
  try {
    const getGrayList = http('fmk.grayTask.front.user.list', { time: random() }, { appkey: 55111, ...axios })
    let list = await getGrayList
    list = Array.isArray(list) ? list : []
    let grayModules = sessionStorage.ERPGRAYMODULE
    grayModules = grayModules ? grayModules.split(',') : []
    // 对比前后灰度前端包是否一致
    const newArr = [...list, ...grayModules]
    const diffArr = newArr.filter(v => !(list.includes(v) && grayModules.includes(v)))
    const isPublic = checkPublicGray(list)
    sessionStorage.setItem('ERPGRAYMODULE', list.join(','))
    // 有差异或者public灰度
    if (diffArr.length > 0 || isPublic) {
      window.__intercept__ = 0
      location.reload()
    }
  } catch (e) {
    sessionStorage.setItem('ERPGRAYMODULE', '')
    console.error('getGrayModule:error', e)
    // throw e
  }
}

const hot = {
  actions: {
    async caslogin ({ commit, dispatch, state }, params) {
      try {
        // let pwdExpired = params.password_expired
        delete params.password_expired
        let { access_token, business_id } = await service.get(API.validate, { params })
        setToken(access_token)
        let id = localStorage.ERPCacheFlag
        location.hash = business_id === id && state.oldPath ? `#${state.oldPath}` : '#/'
        state.oldPath = ''
        window.__ERP__diffAccount__ = business_id !== id
        checkReload(business_id !== id && state.user && state.user.id, params.gray)
        // task:107738 去掉修改密码提示
        // pwdExpiredTips(pwdExpired)
      } catch (e) {
        location.hash = `#/error?type=${LOGIN_ERROR_TYPES.login}`
      }
    },
    logout (ctx, type) {
      let token = getToken()
      if (token) {
        setToken()
        http('cas.authorize.deleteToken', { access_token: token }, false)
      }
      // token 过期，不刷新页面
      if (type === LOGIN_ERROR_TYPES.expired) {
        store.commit('SET_MENUS')
        store.commit('INIT_PERMISSION')
        window.__ERP_IS_AGAIN_LOGIN = true
        bus.$emit('GLOBAL_LOGOUT')
        location.hash = '#/login'
      } else {
        location.hash = ''
        window.__intercept__ = 0
        location.reload()
      }
    },
    async getGlobalData ({ commit, dispatch }) {
      checkGrayModules()
      try {
        commit('SET_LOADING', true)
        const getPermission = http(API.permission, {time: random()}, axios)
        const getPermissionCode = http(API.permissionCode, {time: random()}, axios)
        const getMenus = http(API.menu, {time: random()}, axios)

        let permission = await getPermission
        let permissionCode = await getPermissionCode
        let menus = await getMenus

        if (window.__ERPLOOKUP__) {
          commit('SET_LOOKUP_OPTIONS', window.__ERPLOOKUP__)
        } else {
          let e = { type: LOGIN_ERROR_TYPES.lookup, key: 'lookup' }
          throw e
        }
        // 2022-09-01 非生产环境去掉api校验，只保留权限编码
        ENV === 'prd' && commit('SET_PERMISSION', permission)
        commit('SET_PERMISSION_CODE', permissionCode)
        commit('SET_MENUS', menus)
        commit('SET_LOADING', false)

        dispatch('getUser')
        dispatch('getProvinces')
        // dispatch('getDepartmentLabel')
      } catch (e) {
        commit('SET_LOADING', false)
        if (e && Object.values(API).includes(e.method)) {
          let type = LOGIN_ERROR_TYPES[e.method]
          e.type = type
          e.key = LOGIN_ERROR_TYPES[type]
        }
        console.error('getGlobalData:error', e)
        throw e
      }
    },
    async getDepartmentLabel ({ commit }) {
      let departmentLabel = await http(API.departmentLabel, {}, {
        ...axios,
        cancel: false
      })
      commit('SET_DEPARTMENT_LABEL', departmentLabel)
    },
    async getUser ({ commit }) {
      defineFreezeProperty(window, '__ERPUSER__', {})
      let user = await http(API.user, {}, axios)
      commit('SET_USER', user)
      let avatar = await http('kuasheng.employee.getEmployeeHeadPic', { employeeNumbers: [user.employeeNumber] }, axios)
      commit('SET_USER_AVATAR', avatar)
    },
    async getProvinces ({ commit }) {
      let method = API.address
      let params = {
        method,
        jsonrpc: '2.0',
        id: random().toString().substr(4),
        params: { districtLevel: 'province' }
      }
      let { districtList } = await http(method, params, { ...axios, appkey: 55844 })
      if (districtList && districtList.length) {
        commit('SET_PROVINCES', districtList.map(v => Object.freeze({
          id: v.districtID,
          code: v.adminCode,
          addressName: v.districtName
        })))
      }
    },
    setOldPath ({ state }, params) {
      const { oldPath = '' } = params
      state.oldPath = oldPath
    }
  }
}

store.hotUpdate(hot)



// WEBPACK FOOTER //
// ./src/layout/store/index.js